import { skipToken, type SkipToken } from '@apollo/client/react'
import { isFunction } from 'lodash-es'

export type Truthy<T> = Exclude<T, null | undefined | false | 0 | ''>

/** Options, or a builder that receives the condition's value narrowed. */
export type OptionsOrBuild<TValue, TOptions> = TOptions | ((value: Truthy<TValue>) => TOptions)

/** Core of `useGatedQuery` and `useReconnectingSubscription`; lint bars importing it anywhere else. */
export const skipTokenUnless = <TValue, TOptions extends object>(
  value: TValue,
  optionsOrBuild: OptionsOrBuild<TValue, TOptions>,
): TOptions | SkipToken => {
  if (!value) {
    return skipToken
  }

  return isFunction(optionsOrBuild) ? optionsOrBuild(value as Truthy<TValue>) : optionsOrBuild
}
